export default __webpack_public_path__ + "static/media/tortufruta.108e1a84.jpeg";